import { useEffect } from 'react';

type PageFlow = 'apply' | 'interview';

const flowTitles: Record<PageFlow, (clientName: string) => string> = {
  apply: (clientName) => `${clientName} — Apply`,
  interview: (clientName) => `${clientName} — Interview`,
};

export const usePageTitle = (clientName: string | undefined, flow: PageFlow) => {
  useEffect(() => {
    if (clientName) {
      document.title = flowTitles[flow](clientName);
    }
  }, [clientName, flow]);
};
